export default __webpack_public_path__ + "static/media/4.e867328c.webp";